import { useState } from "react";
import PropTypes from "prop-types";

// import mui icons
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

function AgGridCheckboxFilter({ values = [], getSelectedValues = () => {} }) {
    const [selectedValues, setSelectedValues] = useState([]);

    const handleOnChange = (event, label, type = "individualCheck") => {
        let datum = [...selectedValues];

        if (type === "individualCheck") {
            if (label) {
                if (event.target.checked) {
                    datum = [...datum, label];
                } else {
                    const index = datum.indexOf(label);
                    if (index !== -1) {
                        datum.splice(index, 1);
                    }
                }
            }
        } else if (type === "allCheck") {
            if (event.target.checked) {
                datum = [...values];
            } else {
                datum = [];
            }
        }
        setSelectedValues([...datum]);
        getSelectedValues(datum);
    };

    return (
        <>
            <div
                style={{
                    marginTop: 5,
                    marginBottom: 5,
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        borderBottom: "1px solid grey",
                    }}
                >
                    <FormControlLabel
                        sx={{
                            "& .MuiTypography-root": {
                                fontSize: 12,
                                margin: "5px 0px",
                                padding: 0,
                                display: "block",
                                paddingLeft: 1,
                            },
                        }}
                        style={{
                            display: "flex",
                            margin: "0px 0px 0px 0px",
                            padding: "0px 8px",
                            textAlign: "left",
                        }}
                        control={
                            <Checkbox
                                sx={{
                                    "& .MuiSvgIcon-root": {
                                        fontSize: 18,
                                        padding: 0,
                                    },
                                }}
                                style={{
                                    padding: 5,
                                }}
                                color="primary"
                                value="Select All"
                                onChange={(event) => handleOnChange(event, null, "allCheck")}
                                checked={selectedValues.length === values.length ? true : false}
                            />
                        }
                        label="Select All"
                    />
                </div>
                {values.map((label, i) => {
                    return (
                        <div
                            key={i}
                            style={{
                                paddingLeft: 25,
                            }}
                        >
                            <FormControlLabel
                                sx={{
                                    "& .MuiTypography-root": {
                                        fontSize: 12,
                                        margin: "5px 0px",
                                        padding: 0,
                                        display: "block",
                                        paddingLeft: 1,
                                    },
                                }}
                                control={
                                    <Checkbox
                                        sx={{
                                            "& .MuiSvgIcon-root": {
                                                fontSize: 18,
                                                padding: 0,
                                            },
                                        }}
                                        style={{
                                            padding: 5,
                                        }}
                                        color="primary"
                                        onChange={(event) => handleOnChange(event, label, "individualCheck")}
                                        value={label}
                                        checked={selectedValues.includes(label) ? true : false}
                                    />
                                }
                                label={label}
                            />
                        </div>
                    );
                })}
            </div>
        </>
    );
}

// Typechecking props for the OverallKpi
AgGridCheckboxFilter.propTypes = {
    values: PropTypes.array,
    getSelectedValues: PropTypes.func,
};

export default AgGridCheckboxFilter;
